declare global {
  interface Window {
    onCayletTurnstile?: (token: string) => void;
    turnstile?: { reset: () => void };
  }
}

let scriptPromise: Promise<void> | null = null;

export function loadTurnstile(onToken: (token: string) => void): Promise<void> {
  window.onCayletTurnstile = onToken;
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("turnstile_load_failed"));
    document.head.append(script);
  });
  return scriptPromise;
}
